<template>
    <div>
        <v-navigation-drawer
          temporary
          dark
          v-model="leftSidebar"
          light
          overflow
          absolute
        >
            <v-list>
                <v-list-group v-for="(item,index) in menuItems" :value="item.active" v-bind:key="index">
                    <v-list-tile 
                        v-bind:to="item.link"
                        slot="item" 
                        v-on:click="">
                        <v-list-tile-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="hasSub(item)">
                            <v-icon>keyboard_arrow_down</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-list v-if="hasSub(item)">
                    <v-list-tile  
                        
                        v-for="(sub,index) in item.sub" 
                        v-if="isAllowed(sub.title)"
                        v-bind:key="index" 
                        v-bind:to="sub.link">
                        <v-list-tile-content >
                            <v-list-tile-title>{{ sub.title }}</v-list-tile-title>
                        </v-list-tile-content>
                        
                    </v-list-tile>
                    </v-list>
                </v-list-group>
            </v-list> 
            <v-divider></v-divider>
            <v-list v-if="isAuth">
                <v-list-tile v-on:click="logout()">       
                    <v-list-tile-action>
                            <v-icon left>exit_to_app</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>                            
                            Logout
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar dark fixed dense>
            <span class="hidden-md-and-up" v-on:click.stop="leftSidebar = !leftSidebar"> 
                <v-toolbar-side-icon> </v-toolbar-side-icon> 
            </span>
            <v-toolbar-title><router-link to="/dashboard"><img :src="basePath + 'storage/img/logo.png'" width="150px"></router-link> </v-toolbar-title>
            
            <v-spacer></v-spacer> 
            <v-text-field
                    class="mb-0 pb-0 caption"
                    v-if="isSearch"
                    name="search"
                    label="search"
                    id="search"
                    v-model="search"
                    
                ></v-text-field>
            <v-toolbar-items class="hidden-sm-and-down">

                <v-btn 
                    flat 
                    v-if="isAuth"
                    class="mb-2 pb-0 caption" 
                    v-on:click.stop="toggleSearch"
                    v-click-outside="hideSearch"
                    >
                  <v-icon >search</v-icon>
                </v-btn>   
                <v-btn 
                    flat  
                    v-if="isAuth"
                    class="mb-2 pb-0 caption" 
                    v-on:click="toggleFilter()">
                    <v-icon left large color="red" v-if="filteredList">filter_list</v-icon>
                    <v-icon left v-else>filter_list</v-icon>
                    Filter
                </v-btn>                 
                <v-spacer></v-spacer>
                <v-menu 
                        offset-y
                        bottom
                        v-for="(item, index) in menuItems"
                        v-bind:key="index"
                        >
                    <v-btn                        
                        flat
                        class="caption"
                        slot="activator"
                        v-bind:to="item.link"
                        v-on:click=""
                        >
                        <v-icon left dark>{{ item.icon }}</v-icon>
                        {{ item.title }}
                    </v-btn>                    
                    <v-list v-if="hasSub(item)">
                        <v-list-tile                                 
                                v-for="(sub,index) in item.sub" v-if="isAllowed(sub.title)"
                                v-bind:key="index"
                                v-bind:to="sub.link">
                            <v-list-tile-title class="caption">
                                {{ sub.title }}
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                    
                </v-menu>

            
                <v-btn 
                    flat 
                    v-if="isAuth"
                    class="caption mb-2 pb-0 hidden-sm-and-down" 
                    v-on:click="logout()">
                    <v-icon left>exit_to_app</v-icon>
                    Logout
                </v-btn>  
                
            </v-toolbar-items>
        </v-toolbar>
        <filter-modal></filter-modal>
    </div>   
</template>

<script>

import filterModal from '../shared/FilterModal.vue'

export default {   
    
    created() {
        this.$store.commit('showFilterDialog', false)
        
    },
    components: {
        'filter-modal': filterModal,      
    },
    
    data() {
        return {            
            showModal: false,
            leftSidebar: false,
            isSearch: false,
        }
    },
    computed: {
        basePath: function() {
            return this.$axios.defaults.baseURL
        },        
        search: {
          get () {
            return this.$store.state.search
          },
          set (value) {
            this.$store.commit('updateSearch', value)
          }
        },
        
        isAuth: function() {
            return this.$store.getters.isAuth
        },
        authUser: function() {
            return this.$store.getters.authUser;
        },
        menuItems: function() {
            return this.$store.getters.menuItems;
        },
        filteredList: function() {
            return this.$store.getters.preFilteredFirmen.length > 0 || 
                    this.$store.getters.preFilteredMarken.length
        }
        
        
    },
    methods: {
        
        toggleSearch: function() {
            this.search = ""
            
            return this.isSearch=true
        },
        hideSearch: function() {
            this.search=""
            return this.isSearch=false
        },
        toggleFilter: function() {    
            this.$store.dispatch('setWarengruppen')
            this.$store.dispatch('setTypes')
            if (this.filteredList) {
                this.$store.commit('setPreFilteredFirmen', [])
                this.$store.commit('setPreFilteredMarken', [])              
                this.$store.commit('showFilterDialog', false)
            } else {
                this.$store.commit('showFilterDialog', true)
            }
            
        },
        hasSub: function(item){                 
            return item.sub.length
        },
        logout: function() {
            this.$dmAuth.killToken();
            this.$store.commit('killAuthUser')
            this.$store.commit('setAuth')
            window.localStorage.clear();
            this.$router.push('/login')                      
        },
        //quick and dirty
        isAllowed: function(elem){
            if(elem == "Passport" || elem == "Import") {
                return this.authUser.roles.some(function(role){
                    return role.name.match('Admin')
                })
            console.log(elem)
            }
            return true
        },
        register: function() {
            
        }
    }
    
}
</script>

<style>
    
    
    
</style>



// WEBPACK FOOTER //
// Header.vue?58c51342